import { adjustTime } from '@shared/utils';

import { errorMapping } from '../../constants';
import type {
  ExamEventSession,
  PostponeTimeErrorCode,
  TimePostponementErrorState,
  TimePostponementSessionState,
} from '../../types';

export function adjustExamEventTime(
  startTime: Date,
  endTime: Date,
  postponeDurationInMs?: number | null,
) {
  const postponeDuration = postponeDurationInMs ?? 0;

  return {
    start: adjustTime(startTime, postponeDuration),
    end: adjustTime(endTime, postponeDuration),
  };
}

export function mapOriginalSessions(examEventSessions: ExamEventSession[]) {
  return [...examEventSessions]
    .sort((a, b) => a.round - b.round)
    .map((session) => {
      const adjustedTime = adjustExamEventTime(
        session.startedAt,
        session.endedAt,
        session.postponeDurationInMs,
      );

      return {
        round: session.round,
        start: adjustedTime.start,
        end: adjustedTime.end,
      };
    });
}

export function mapPostponedSessions(
  sessions: TimePostponementSessionState[],
  postponeDurationInMinutes: number,
) {
  const postponeDurationInMs = postponeDurationInMinutes * 60 * 1000;

  return sessions.map((session) => {
    const postponedTime = adjustExamEventTime(
      session.start ?? new Date(0),
      session.end ?? new Date(0),
      postponeDurationInMs,
    );

    return { ...session, ...postponedTime };
  });
}

export function mapErrorCodeToMessage(
  errorCode: PostponeTimeErrorCode,
): TimePostponementErrorState | undefined {
  switch (errorCode) {
    case 'EXAM_SESSION_ALREADY_STARTED':
    case 'EXAM_EVENT_POSTPONE_ALREADY_UPDATED':
      return {
        alertError: errorMapping[errorCode],
      };
    case 'EXAM_SESSION_END_TIME_EXCEEDS_MIDNIGHT':
      return {
        sessionTimeError: errorMapping[errorCode],
      };
  }
}
